import React from 'react'

export const Offers = () => {
	return <div>offers</div>
}
